import { Grid } from '@mui/material';
import TextField from '@mui/material/TextField';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { ContactFieldValue } from '../../../../../sic-lib/types/ContactField';
import EditButtonGroup from '../../../../Shared/FormControls/Buttons/EditButtonGroup';

const useStyles = makeStyles()((theme: Theme) => ({
    rootGrid: {
        display: 'contents',
    },
    txtName: {
        marginLeft: theme.spacing(10),
    },
    txtEditName: {
        color: 'grey',
    },
    editBtn: {
        marginRight: theme.spacing(3),
    },
}));

interface ComponentState {
    firstName: string;
    lastName: string;
    salutation: ContactFieldValue;
}

interface Props {
    menuId: string;
    firstName: string;
    lastName: string;
    salutation: ContactFieldValue;
    onCloseHandler: () => void;
    onSubmitHandler: (firstName: string, lastName: string, salutation: ContactFieldValue) => void;
}
export default function MenuSetContactNameRaw({
    menuId,
    firstName,
    lastName,
    salutation,
    onCloseHandler,
    onSubmitHandler,
}: Props) {
    const { classes } = useStyles();

    const [fullName, setFullName] = React.useState<ComponentState>({
        firstName,
        lastName,
        salutation,
    });
    const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value, name } = event.target;
        setFullName({ ...fullName, [name]: value });
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Enter')
            onSubmitHandler(fullName.firstName, fullName.lastName, fullName.salutation);
    };

    const handleSubmit = () => {
        onSubmitHandler(fullName.firstName, fullName.lastName, fullName.salutation);
    };

    return (
        <React.Fragment>
            <Grid
                className={classes.rootGrid}
                container
                justifyContent="center"
                alignItems="center"
            >
                <Grid item xs className={classes.txtName} onKeyDown={handleKeyDown}>
                    <TextField
                        id={menuId}
                        name="firstName"
                        placeholder="First Name"
                        onChange={handleChange}
                        value={fullName.firstName}
                        autoFocus
                    />
                    <TextField
                        id={menuId}
                        name="lastName"
                        placeholder="Last Name"
                        onChange={handleChange}
                        value={fullName.lastName}
                    />
                    <TextField
                        id={menuId}
                        name="salutation"
                        placeholder="Salutation"
                        onChange={handleChange}
                        value={fullName.salutation}
                    />
                </Grid>
                <Grid item className={classes.editBtn}>
                    <EditButtonGroup
                        onSave={handleSubmit}
                        onCancel={onCloseHandler}
                        allowDelete={false}
                        size="small"
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
